import { useCallback, useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { tintFor } from "../../utils/tints";
import ring from "../../assets/img/portal-ring.png";
import { SignalIcon } from "../hand/icons";
import "./people.css";

export function SectionHeading({ children, detail }) {
  return (
    <div className="people-section-heading">
      <h2>{children}</h2>
      {detail && <span>{detail}</span>}
      <i />
    </div>
  );
}
export function Faces({ people = [] }) {
  return (
    <span className="people-faces">
      {people.slice(0, 3).map((p, i) => (
        <span
          key={p.userId || i}
          title={p.displayName || p.name}
          style={{ background: tintFor(p.userId || p.name) }}
        >
          {p.avatarUrl ? (
            <img src={p.avatarUrl} alt="" referrerPolicy="no-referrer" />
          ) : (
            (p.displayName || p.name || "?")[0]
          )}
        </span>
      ))}
    </span>
  );
}
export function RingButton({ onClick, label, dark = false, children }) {
  return (
    <button
      type="button"
      className={`people-ring-button ${dark ? "is-dark" : ""}`}
      onClick={onClick}
      aria-label={label}
    >
      <img src={ring} alt="" />
      <span>
        {children || <SignalIcon size={15} />}
      </span>
    </button>
  );
}
export function ShareGlyph() {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.2"
    >
      <path d="M4 12v9h16v-9M12 16V3M6 9l6-6 6 6" />
    </svg>
  );
}
export function usePeopleToast() {
  const [toast, setToast] = useState(null);
  const timer = useRef();
  useEffect(() => () => clearTimeout(timer.current), []);
  const notify = useCallback((message, undo) => {
    clearTimeout(timer.current);
    setToast({ message, undo });
    timer.current = setTimeout(() => setToast(null), 3200);
  }, []);
  const element =
    toast &&
    createPortal(
      <div className="pr-overlay-root people-toast" role="status">
        <i />
        <span>{toast.message}</span>
        {toast.undo && (
          <button
            type="button"
            onClick={() => {
              clearTimeout(timer.current);
              setToast(null);
              toast.undo();
            }}
          >
            Undo
          </button>
        )}
      </div>,
      document.body
    );
  return [notify, element];
}
export const errorMessage = (result, fallback) =>
  typeof result?.error === "string"
    ? result.error
    : result?.error?.message || fallback;
export function ago(iso) {
  const mins = Math.max(
    0,
    Math.floor((Date.now() - new Date(iso).getTime()) / 60000)
  );
  if (!Number.isFinite(mins)) return "";
  return mins < 1
    ? "NOW"
    : mins < 60
    ? `${mins}M`
    : mins < 1440
    ? `${Math.floor(mins / 60)}H`
    : `${Math.floor(mins / 1440)}D`;
}
